module.exports = __webpack_public_path__ + "img/myself01-web.51ea6f9c.png";